const url = 'https://api-zermatlideres.azurewebsites.net'   // Original de Producción
//const url = 'http://localhost:8008';      // Local Pruebas
//const url = 'http://localhost:8080';      // Local Producción
 //const url = 'https://api-lideres-stage.azurewebsites.net'


export default url